<template>
  <v-tabs v-bind="$attrs" class="tw-w-auto" style="flex: 0">
    <v-tab v-for="item in navigation"
           :key="item.value"
           v-model="active"
           exact
           :to="{name: item.url}">
      <span class="tw-font-bold tw-tracking-normal">{{ item.value }}</span>
    </v-tab>
  </v-tabs>
</template>

<script>
import headerNavigation from '@/common/data/globalHeaderNavigation'
export default {
  name: 'TraditionalHeaderNavigationTabs',
  data: function () {
    return {
      active: 'Home',
      navigation: headerNavigation
    }
  },
  created () {
    const pathArr = this.$route.path.split('/')
    console.log(pathArr)
    this.active = this._.capitalize(pathArr[1]) || 'Home'
  }
}
</script>

<style lang="scss" scoped>

</style>
